import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { getPeriodBoundariesFromStartDateAndGranularity } from '../../../../common/utils/datetime.util';
import { GetAccountSentimentReportAverageSummaryRequestDto } from '../../../../interface/dtos/sentiment/get-account-sentiment-report-average-summary.request.dto';
import { AccountSentimentReportAverageSummaryAggregateRoot } from '../../../domain/aggregates/sentiment/account-sentiment-report-average-summary.aggregate-root';
import { GetAccountSentimentReportAverageSummaryDomainService } from '../../../domain/services/sentiment/get-account-sentiment-report-average-summary.domain-service';
import { OrgSentimentReportPort } from '../../ports/org-sentiment-report/org-sentiment-report.port';

export class GetAccountSentimentReportAverageSummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrgSentimentReportPort,
    protected readonly domainService: GetAccountSentimentReportAverageSummaryDomainService
  ) {}

  async execute(
    props: GetAccountSentimentReportAverageSummaryRequestDto
  ): Promise<AccountSentimentReportAverageSummaryAggregateRoot> {
    try {
      const [
        startDate,
        endDate,
        previousPeriodStartDate,
        previousPeriodEndDate,
      ] = getPeriodBoundariesFromStartDateAndGranularity(
        new Date(new Date(props.params.startDate).setUTCHours(0, 0, 0, 0)),
        props.params.granularity
      );
      const [thisPeriod, lastPeriod] = await Promise.all([
        this.port.getAccountSentimentReportAverageSummaryForDateRange({
          startDate: startDate.toISOString().split('T')[0],
          endDate: endDate.toISOString().split('T')[0],
          token: props.config.token,
          departmentId: props.params.departmentId ?? undefined,
        }),
        this.port.getAccountSentimentReportAverageSummaryForDateRange({
          startDate: previousPeriodStartDate.toISOString().split('T')[0],
          endDate: previousPeriodEndDate.toISOString().split('T')[0],
          token: props.config.token,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);

      if (!thisPeriod || !lastPeriod) {
        throw new InternalServerErrorException(
          'Both this period and last period must be present.'
        );
      }

      return await this.domainService.execute({ thisPeriod, lastPeriod });
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportAverageSummaryApplicationService.execute encountered an error ${error}`
      );
    }
  }
}
